/**
 * Path prefix for the Gravity Stargate route.
 */
export const getGravityServicePathPrefix = (): string => '/gateway/api/jpd/gravity';
